import { render, staticRenderFns } from "./intelinvest.vue?vue&type=template&id=eb6883e2&scoped=true"
import script from "./intelinvest.vue?vue&type=script&lang=js"
export * from "./intelinvest.vue?vue&type=script&lang=js"
import style0 from "./intelinvest.vue?vue&type=style&index=0&id=eb6883e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6883e2",
  null
  
)

export default component.exports